import { Model } from '@vuex-orm/core'

export class UserParent extends Model {
  static entity = 'userParent'
  static primaryKey = ['user_id', 'parent_id']

  static fields () {
    return {
      user_id: this.attr(null),
      parent_id: this.attr(null),
      relation: this.string(''),
      created_at: this.attr(null)
    }
  }
}

export default UserParent
